import { render, staticRenderFns } from "./SlidesM.vue?vue&type=template&id=48f1d4b9&scoped=true&"
import script from "./SlidesM.vue?vue&type=script&lang=js&"
export * from "./SlidesM.vue?vue&type=script&lang=js&"
import style0 from "./SlidesM.vue?vue&type=style&index=0&id=48f1d4b9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f1d4b9",
  null
  
)

export default component.exports